import { useState } from 'react';
import { HandThumbsDown, HandThumbsUp } from 'react-bootstrap-icons';

import { Button, Space, Typography } from 'antd';

import ImageRatio from '@/components/shared/ImageRatio';
import { getCdnUrl } from '@/helpers';
import { IInvite } from '@/interfaces/invite';
import { useAcceptInviteMutation, useRefuseInviteMutation } from '@/services/invites';
import styled, { css, StyledProp } from '@/styled';

import ConfirmRefuse from './ConfirmRefuse';

const Item = (props: IInvite & StyledProp) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>();
  const [refuseInvite, refusedInvite] = useRefuseInviteMutation();
  const [acceptInvite] = useAcceptInviteMutation();

  const handleAcceptInvite = () => {
    acceptInvite(props.hash);
  };

  const handleOpenRefuseModal = () => {
    setIsModalOpen(true);
  };

  const handleRefuseInvite = () => {
    refuseInvite(props.hash).finally(() => {
      setIsModalOpen(isModalOpen => !isModalOpen);
    });
  };

  return (
    <>
      <ConfirmRefuse
        open={isModalOpen}
        handleRefuseInvite={handleRefuseInvite}
        setOpen={() => setIsModalOpen(false)}
        isLoading={refusedInvite.isLoading}
      />
      <div className={props.className}>
        <ImageRatio
          className='image'
          aspect='16:9'
          src={getCdnUrl(props?.course?.customization?.new_avatar, props?.course?.customization?.avatar)}
          alt='imagem da notificação'
        />
        <Space size={0} rootClassName='content' direction='vertical'>
          <Typography.Text ellipsis>{props?.course?.title}</Typography.Text>
          <Typography.Text ellipsis>Enviado por {props?.course.author.name}</Typography.Text>
          <Space size={16} rootClassName='actions'>
            <Button type='default' icon={<HandThumbsDown size={12} />} onClick={handleOpenRefuseModal}>
              Recusar
            </Button>
            <Button type='default' icon={<HandThumbsUp size={12} />} className='accept' onClick={handleAcceptInvite}>
              Aceitar
            </Button>
          </Space>
        </Space>
      </div>
    </>
  );
};

export default styled(Item)(({ theme }) => {
  return css`
    display: grid;
    align-self: center;
    justify-content: flex-start;
    width: 100%;
    padding: ${theme.space.spacing(3, 6)};
    grid-gap: ${theme.space.pxToRem(8)};
    grid-template-columns: 130px auto;
    border-bottom: 1px solid ${theme.variables.borderColor};

    button {
      padding: ${theme.space.spacing(0, 2)};
      height: 24px;
      border: 1px solid ${theme.variables.borderColor};
      background: ${theme.palette.alpha(theme.palette.gray[0], 0.02)};

      svg {
        margin-right: ${theme.space.pxToRem(4)};
      }
    }

    .accept {
      background: ${theme.palette.alpha(theme.palette.gray[0], 0.1)};
    }

    ${theme.breakpoints.down('md')} {
      grid-template-columns: 100%;

      .image {
        display: none;
      }
    }

    .ant-typography,
    .ant-space-item {
      height: 24px;
    }

    .courseTitle {
      color: ${theme.colorTextTertiary};
    }

    .sideContent {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: flex-end;
    }

    .content {
    }
  `;
});
